/*global
    jQuery, aap
*/
(function ($) {
	if ($('section.petco-contact-signup').length > 0) {
		var $form = $('section.redesign').find('form');

		var fieldActive = function() {
			var $field = $(this);
			$field.parent('div.field').parent('div.inline-form-field').addClass('active');
            if ($field.is('SELECT')) {
                changeSelectStyle($field);
            }
		}

		var showLabel = function($field) {
            if ($field.val() !== '' && $field.parents('div.more').length < 1) {
                $field.parent('div.field').find('label').addClass('show');
                $field.addClass('show');
            } else {
                hideLabel($field);
            }

		}

        var triggerShowLabel = function(e) {
            var $field = $(e.target);
            showLabel($field);

            if ($field.attr('name') === 'contact_method') {
                showContactDetails();
            }

            if ($field.attr('name') === 'contact_timeframe') {
            	showTimeDetails();
            }
        }
        var selectChanged = function(e) {
            var $field = $(this);
            if ($field.is('select')) {
                changeSelectStyle($field);
            }
        }

        var changeSelectStyle = function($field) {
            if ($field.val() === "" || $field.is(':active')) {
                if (!$field.hasClass('unset')) {
                    $field.addClass('unset');
                }
            } else {
                $field.removeClass('unset');
            }
        }
        var triggerHideLabel = function(e) {
            var $field = $(e.target);
            hideLabel($field);
        }

		var hideLabel = function($field) {
			if ($field.val() == '' || typeof $field.val() === 'undefined') {
				$field.parent('div.field').find('label').removeClass('show');
                $field.removeClass('show');
			}
			$field.parent('div.field').parent('div.inline-form-field').removeClass('active');
			if ($form.find('input[name="petco_stores[]"]:checked').length > 0) {
				maybeToggleForm();
            } else {
				validateField($field);
			}
            if ($field.is('SELECT')) {
                changeSelectStyle($field);
            }
		}
		
		var showError = function($field, message) {
			var $wrapper = $field.parent('div.field').parent('div.inline-form-field');
			if ($field.parent('div.more').length > 0) {
				$wrapper = $field.parent('div.more');
			}
			if (typeof message !== 'undefined') {
				$wrapper.find('span.error').html(message);
				$wrapper.find('span.error').show();
			} else {
				$wrapper.find('span.error').html('');
			}
			$wrapper.addClass('error');
		}

		var validateEmail = function(email) {
		    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    return re.test(email);
		}

		var validatePhoneNumber = function(phoneNumber) {
			return (phoneNumber.match(/\d/g) || []).length >=10;
		}

		var showContactDetails = function() {
			$form.find('input[name="contact_details"]').parents('div.more').removeClass('closed');
		}

		var showTimeDetails = function() {
			$form.find('textarea[name="contact_time_details"]').parents('div.more').removeClass('closed')
		}

		var validateField = function($field) {
			var fieldName = $field.attr('name'),
				fieldValue = $field.val(),
				$wrapper = $field.parent('div.field').parent('div.inline-form-field');

			saveFormState();

			if (fieldName === 'name') {
				// Validate name field
				if ($field.is(':focus')) {
					hideError($field);
				} else if (fieldValue.length === 0) {
					showError($field, 'Required');
				} else {
					hideError($field);
				}
			} else if (fieldName === 'contact_method') {
				if ($field.is(':focus')) {
					hideError($field);
				} else if (typeof fieldValue === 'undefined' || fieldValue === '') {
					showError($field);
				} else {
					hideError($field);
				}
			} else if (fieldName === 'contact_details') {
				var contactMethod = $form.find('select[name="contact_method"]').val();
				if ($field.is(':focus')) {
					hideError($field);
				} else if (contactMethod === '') {
					hideError($field);
				} else if (fieldValue.length === 0) {
					showError($field, 'Required');
				} else if (contactMethod === 'email') {
					if (!validateEmail(fieldValue)) {
						showError($field, 'Email address is not valid');
					} else {
						hideError($field);
					}
				} else if (contactMethod === 'call' || contactMethod === 'sms') {
					if(!validatePhoneNumber(fieldValue)) {
						showError($field, 'Phone number is not valid');
					} else {
						hideError($field);
					}
				} else {
					hideError($field);
				}
			} else if (fieldName === 'contact_timeframe') {
				if ($field.is(':focus')) {
					hideError($field);
				} else if (fieldValue.length === 0) {
					showError($field);
				} else {
					hideError($field);
				}
			} else if (fieldName === 'contact_time_details') {
				if ($field.is(':focus')) {
					hideError($field);
				} else if (fieldValue.length === 0) {
					showError($field, 'Required');
				} else {
					hideError($field);
				}				
			} else if (fieldName === 'petco_stores[]') {
				if ($form.find('input[name="petco_stores[]"]:checked').length === 0) {
					showPetcoStoresError();
				} else {
					hidePetcoStoresError();
				}
			}
		}

        var saveFormState = function() {
            var fields = {};

            var elements = $form.find('input, select, textarea');

            $.each(elements, function(key, value) {
                var $field = $(elements[key]);
                if ($field.attr('name') !== '_token' && $field.attr('name') !== 'petco_stores[]') {
                    fields[$field.attr('name')] = $field.val();
                } else if ($field.attr('name') === 'petco_stores[]') {
                	$fields = $form.find('input[name="petco_stores[]"]:checked');
                	var selectedStores = {};
                	$.each($fields, function(k, v){
                		selectedStores[$($fields[k]).attr('id')] = $($fields[k]).val();
                	});
                	fields['petco_stores[]'] = selectedStores;
                }
            });

            try {
                sessionStorage.setItem('cachedContactSignup', JSON.stringify(fields));
            } catch (e) {
                // do nothing, we do not have a way to save field data between page loads without
                // rigging something to work, which might not be the best option
            }
        }

        var loadFormState = function() {
            var oldData = sessionStorage.getItem('cachedContactSignup');
            if (typeof oldData !== 'undefined' && oldData !== null) {
                var oldDataObj = JSON.parse(oldData);
                $.each(oldDataObj, function(key, value){
                	console.log('key');
                	console.log(key);
                	console.log('value');
                	console.log(value);
                    if (value !== '') {
                        if (key === 'contact_method' || key === 'contact_timeframe') {
                            $form.find('select[name="'+key+'"]').val(value);
                            validateField($form.find('select[name="'+key+'"]'));
                            changeSelectStyle($form.find('select[name="'+key+'"]'));
                            if (key ==='contact_method') {
                            	console.log('should show details');
                            	showContactDetails();
                            } else if (key === 'contact_timeframe') {
                            	showTimeDetails();
                            }
                        } else if (key === 'contact_time_details') {
                        	$form.find('textarea[name="'+key+'"]').val(value);
                        	validateField($form.find('textarea[name="'+key+'"]'));
                        } else if (key === 'petco_stores[]') {
                        	$.each(value, function(k,v){
                        		if (!$form.find('input#'+k).is(':checked')) {
                        			$form.find('input#'+k).click();
                        		}
                        	});
                        	validateField($form.find('input[name="'+key+'"]'));
                        } else {
                            $form.find('input[name="'+key+'"]').val(value);
                            validateField($form.find('input[name="'+key+'"]'));
                        }
                    }
                });
            }
        }
        $(window).on('load', loadFormState);
		var showPetcoStoresError = function() {
			$('div.petco-stores').find('span.error-message').removeClass('hidden');
		}

		var hidePetcoStoresError = function() {
			$('div.petco-stores').find('span.error-message').addClass('hidden');
		}
		
		var hideError = function($field) {
			var $wrapper = $field.parent('div.field').parent('div.inline-form-field');
			if ($field.parents('div.more').length > 0) {
				$wrapper = $field.parent('div.more');
			}
			$wrapper.removeClass('error');
			$wrapper.find('span.error').html('');
			$wrapper.find('span.error').hide();
		}

		var focusField = function() {
			//$(this).find('input,select').focus();
		}
		
		var validateForm = function() {
			var fields = $form.find('input, select, textarea');
			$.each(fields, function(key, value) {
				validateField($(fields[key]));
			});
		}

		var maybeToggleForm = function() {
			validateForm();
			var errors = $form.find('div.inline-form-field.error, div.more.error');
			if (errors.length > 0 || !$('div.petco-stores').find('span.error-message').hasClass('hidden')) {
				$form.find('input.submit').attr('disabled', true);
			} else {
				$form.find('input.submit').attr('disabled', false);
			}
		}
		var checkBoxOnRowClick = function(e) {
			var $target = $(e.target).parents('tr');
			$target.find('input[type="checkbox"]').click();
			maybeToggleForm();
		}

		var prefillContactDetails = function(e) {
			var $field = $(e.target),
				fieldValue = $field.val();

			if (fieldValue === 'email') {
				$form.find('input[name="contact_details"]').val($('input[name="prefilled-email"]').val());
			} else if (fieldValue === 'call' || fieldValue === 'sms') {
				$form.find('input[name="contact_details"]').val($('input[name="prefilled-phone"]').val());
			}
		}
        var changeSelectStyle = function($field) {
            if ($field.val() === "" || $field.is(':active')) {
                if (!$field.hasClass('unset')) {
                    $field.addClass('unset');
                }
            } else {
                $field.removeClass('unset');
            }
        }
		$form.find('select[name="contact_method"]').on('change', prefillContactDetails);

		//$form.find('div.inline-form-field').on('click', focusField);
		$form.find('select').on('click', function(e){
			var $field = $(e.target);
			if ($field.hasClass('unset')) {
				$field.removeClass('unset');
			}
		});
		$form.find('select, input, textarea').on('focus', fieldActive);
		$form.find('select, input, textarea').on('keyup change', triggerShowLabel);
		$form.find('select, input, textarea').on('blur', triggerHideLabel);
        $form.find('select').on('change', selectChanged);
		$('table.petco-store-list').find('tr').on('click', checkBoxOnRowClick);
	}
}(jQuery));